// extracted by mini-css-extract-plugin
module.exports =  {"isPercentage":"isPercentage_avo6pAE5"};